export default __webpack_public_path__ + "static/media/small-delete-icon.080c7de2.svg";